import { render, staticRenderFns } from "./ExpertViewTable.vue?vue&type=template&id=956d4c66"
import script from "./ExpertViewTable.vue?vue&type=script&lang=js"
export * from "./ExpertViewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports